module.exports = __webpack_public_path__ + "img/IsDasNormal.5c8a1dff.svg";